

























import { Component, Vue } from "vue-property-decorator";
import NavBar from "@/components/NavBar.vue";
import { authenticationService } from "@/_services";
import { Role } from "@/_helpers";
import { router } from "./router";

@Component({
  components: {
    NavBar,
  },
})

export default class App extends Vue {
  token = localStorage.token;
  showNav = false;
  currentUser: any;

  isAdmin() {
    return this.currentUser && this.currentUser.role === Role.Admin;
  }

  created() {
    authenticationService.currentUser.subscribe((x: null) => (this.currentUser = x));

    if(localStorage.currentUser){
      this.showNav = true;
    }
  }

  logout() {
    this.showNav = false;
    authenticationService.logout();
    router.push("/");
  }

  updated() {
    if (!localStorage.currentUser) {
      this.showNav = false;
      router.push("/");
    } else {
      //this.token = localStorage.token;
      this.showNav = true;
    }
  }

  mounted() {
    if (!localStorage.currentUser) {
      this.showNav = false;
      router.push("/");
    } else {
      //this.token = localStorage.token;
      this.showNav = true;
    }
  }
}

// export default class App extends Vue {}
